import { useEffect, useState } from 'react'
import FormParams from '~/src/types/forms/FormParams'
import * as yup from 'yup'
import { useTranslations } from '~/src/hooks/useTranslations'
import { useEoValue } from '~/src/hooks/useEoState'
import { CustomerProfileFormInterface } from '~/src/types/forms/CustomerProfileFormInterface'
import { CUSTOMER_STATE } from '~/src/stores/customer'
import ValidatorUtils from '~/src/utils/ValidatorUtils'

const useCustomerProfileForm = (): FormParams<CustomerProfileFormInterface> => {
  const customer = useEoValue(CUSTOMER_STATE)
  const { t } = useTranslations()
  const [ initialValues, setInitialValues ] = useState<CustomerProfileFormInterface>({
    email: customer?.email || '',
    firstName: customer?.first_name || '',
    lastName: customer?.last_name || '',
    phone: (customer?.phone && ValidatorUtils.isPhoneNumberValid(customer?.phone)) ? customer.phone : ''
  })
  const validationSchema = yup.object({
    email: yup
      .string()
      .required(t('errors.email_required'))
      .email(t('errors.email_invalid')),
    firstName: yup
      .string()
      .required(t('errors.firstName_required')),
    lastName: yup
      .string()
      .required(t('errors.lastName_required')),
    phone: yup
      .string()
      .required(t('errors.phone_required'))
      .min(5)
      .test('isNumberValid', t('errors.phone_wrong_format'), ValidatorUtils.isPhoneNumberValid)
  })

  useEffect(() => {
    setInitialValues({
      email: customer?.email || '',
      firstName: customer?.first_name || '',
      lastName: customer?.last_name || '',
      phone: (customer?.phone && ValidatorUtils.isPhoneNumberValid(customer?.phone)) ? customer.phone : ''
    })
  }, [ customer ])

  return { initialValues, validationSchema }
}

export default useCustomerProfileForm
